// extracted by mini-css-extract-plugin
export default {"actAsAgencyBtn":"Concierge_actAsAgencyBtn__WKrKH"};